import { CreateOptionInput } from '@akin-home/amplify';
import { OptionModel } from '@akin-home/options';

export const optionModelToCreateMutationInput = (
  option: OptionModel
): CreateOptionInput => ({
  type: option.type,
  label: option.label,
  code: option.code,
  icon: option.icon as string | undefined,
});
